<mat-form-field>
    <mat-label>Internal Document Type</mat-label>
    <mat-select
        [(value)]="internalDocumentTypeSelected"
        [compareWith]="compareCategoryObjects"
        name="internalDocumentName"
        required="true"
        (selectionChange)="updateDocument($event)"
        [disabled]="disabled"
    >
        <mat-option *ngFor="let type of types | activeInternalDocument" [value]="type">
            {{ type.internalDocumentName }}
        </mat-option>
    </mat-select>
    <!--Have to use mat-hint as mat-error is only available within <form>-->
    <mat-hint *ngIf="internalDocumentNotSelected">Internal Document Type is required</mat-hint>
</mat-form-field>
